export default __webpack_public_path__ + "static/media/JioNewsImage.4737cc7b.png";